export type PerClientEntry = Record<string, unknown> & { client_id: string }

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value)

export const isPerClientArray = (value: unknown): value is PerClientEntry[] =>
  Array.isArray(value) && value.length > 0 && value.every((item) => isRecord(item) && typeof item.client_id === 'string')

export const outputsHavePerClientArray = (outputs: Record<string, unknown>): boolean => Object.values(outputs).some(isPerClientArray)
